class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.initRelatedSlider();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.initRelatedSlider();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initRelatedSlider(){
    if($("cart-drawer .related-product-item").length != 0)
    {
      //if(!$(".related-product-items").hasClass("slick-initialized"))
      //{
        // $("cart-drawer .related-product-items").slick({
        //   slidesToShow: 2.1,
        //   slidesToScroll: 2.1,
        //   arrows: true,
        //   dots: true,
        //   infinite: false,
        //   prevArrow: $("cart-drawer .related-products").find('.custom-prev'),
        //   nextArrow: $("cart-drawer .related-products").find('.custom-next'),
        //   touchThreshold: 25,
        //   swipe:true,
        //   swipeToSlide:true,
        //   responsive: [
        //     {
        //       breakpoint: 768,
        //       settings: { 
        //         slidesToShow: 2.1,
        //         slidesToScroll: 1 }
        //     },
        //     {
        //       breakpoint: 575,
        //       settings: { 
        //         slidesToShow: 1.2,
        //         slidesToScroll: 1 }
        //     }
        //   ]
        // });

        (function(){
        const section = document.getElementById('CartDrawer');
        if(!section) return;

        const rail    = section.querySelector('.related-product-items');
        const slides  = Array.from(section.querySelectorAll('.related-product-item'));
        const prevBtn = section.querySelector('.custom-prev');
        const nextBtn = section.querySelector('.custom-next');
        const dotsWrap = section.querySelector('.slider-pages') || section.querySelector('.slider-dots');

        if(!rail || slides.length === 0) return;

        let currentSlide = 0;
        let currentPage = 0;
        const totalPages = 2; // always 2 dots (like your design)

        const clamp = (n,min,max)=>Math.max(min,Math.min(max,n));

        /* ========== Horizontal Scroll Logic ========== */
        function scrollToSlide(i){
          currentSlide = clamp(i, 0, slides.length - 1);
          const x = slides[currentSlide].offsetLeft;
          rail.scrollTo({ left: x, behavior: 'smooth' });
          updateArrows();
        }

        function scrollToPage(p){
          currentPage = clamp(p, 0, totalPages - 1);
          const maxLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const left = (totalPages === 1) ? 0 : maxLeft * (currentPage / (totalPages - 1));
          rail.scrollTo({ left, behavior: 'smooth' });
        }

        /* ========== Dots ========== */
        function buildDots(){
          if(!dotsWrap) return;
          dotsWrap.innerHTML = '';
          for(let i=0;i<totalPages;i++){
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.role = 'tab';
            dot.setAttribute('aria-label', `Go to page ${i+1}`);
            dot.addEventListener('click', () => scrollToPage(i));
            dotsWrap.appendChild(dot);
          }
          updateDots();
        }

        function updateDots(){
          if(!dotsWrap) return;
          dotsWrap.querySelectorAll('button').forEach((b, i)=>{
            b.setAttribute('aria-selected', i===currentPage ? 'true':'false');
          });
        }

        /* ========== Arrow State (Disable at edges) ========== */
        function updateArrows(){
          const scrollLeft = Math.round(rail.scrollLeft);
          const maxScrollLeft = Math.round(rail.scrollWidth - rail.clientWidth - 2); // tolerance
          const atStart = scrollLeft <= 0;
          const atEnd = scrollLeft >= maxScrollLeft;

          prevBtn.disabled = atStart;
          nextBtn.disabled = atEnd;
        }

        /* ========== Sync Page Indicator ========== */
        function syncPageFromScroll(){
          const maxLeft = Math.max(1, rail.scrollWidth - rail.clientWidth);
          const progress = rail.scrollLeft / maxLeft;
          const p = Math.round(progress * (totalPages - 1));
          if(p !== currentPage){ currentPage = p; updateDots(); }
          updateArrows();
        }

        /* ========== Event Listeners ========== */
        prevBtn?.addEventListener('click', e=>{
          e.preventDefault();
          scrollToSlide(currentSlide - 1);
        });
        nextBtn?.addEventListener('click', e=>{
          e.preventDefault();
          scrollToSlide(currentSlide + 1);
        });

        // prevent focus jump
        [prevBtn, nextBtn].forEach(btn => btn?.addEventListener('mousedown', e=>e.preventDefault()));

        let raf = null;
        rail.addEventListener('scroll', ()=>{
          if(raf) return;
          raf = requestAnimationFrame(()=>{
            raf = null;
            syncPageFromScroll();
          });
        });

        window.addEventListener('resize', syncPageFromScroll);

        // init
        buildDots();
        updateArrows();
      })();
     
    }
    else
    {
      $("cart-drawer .related-products").hide();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
